import { Loading } from 'components/loading/Loading';
import { tableStyles } from 'css/tableStyles';
import React, { useEffect, useState } from 'react';
import { fetchUsers } from 'services/api/users';
import { DATE_FORMATS, formatDate, getPageLimit, showError, updatePageLimit } from 'utils';
import styles from './index.module.scss';
import qs from 'query-string';
import DataTable from 'components/DataTable';
import Filter from './Filter';
import ActionButton from 'components/ActionButton';
import CustomLink from 'components/TableLink';

let filters: { [p: string]: any; page: number } = {
  page: 0,
};

const columns = [
  {
    name: 'UserID',
    selector: 'objectId',
    sortable: false,
    width: '120px',
    // eslint-disable-next-line react/display-name
    cell: row => (
      <CustomLink
        text={row.objectId}
        linkTo={`/users/${row.objectId}`}
      />
    ),
  },
  {
    name: 'Created At',
    selector: 'createdAt',
    format: row => formatDate(row.createdAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A),
  },
  {
    name: 'Name',
    selector: 'full_name',
  },
  {
    name: 'Username',
    selector: 'username',
  },
  {
    name: 'Phone',
    selector: 'phone',
    format: row => row.phone ? row.phone : '-',
  },
];

const Users = props => {
  const [users, setUsers] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState<boolean>(false);
  
  const fetchUsersFn = async () => {
    setLoading(true);
    const { page, ...rest } = filters;
    try {
      const response = await fetchUsers({
        page,
        filter: { ...rest },
        limit: getPageLimit(),
      });
      setUsers(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchUsersFn();
  }, []);
  
  const filterToQueryString = () => {
    return qs.stringify({ ...filters });
  };

  const updateQueryString = () => {
    const qs = filterToQueryString();
    props.history.push({
      pathname: props.location.pathname,
      search: qs,
    });
  };

  const onChangePage = (page: number) => {
    filters.page = page - 1;
    updateQueryString();
    fetchUsersFn();
  };

  const onChangeRowsPerPage = (rowsPerPage: number, currentPage: number) => {
    filters.limit = rowsPerPage;
    updatePageLimit(rowsPerPage);
    onChangePage(currentPage);
  };

  const onFilterSubmit = (updatedFilter: Record<string, any>) => {
    if (updatedFilter.userId) {
      props.history.push(`/users/${updatedFilter.userId}`);
    } else {
      filters = { ...updatedFilter, page: 0 };
      updateQueryString();
      fetchUsersFn();
    }
  };

  return (
    <div>
      <div className={styles['header']}>
        <div className={styles['heading']}>Users</div>
        <ActionButton
          text={<>User <span>+</span></>}
          active={true}
          isLoading={false}
          onClick={() => props.history.push('/users/create')}
        />
      </div>
      <Filter
        {...props}
        onSubmit={onFilterSubmit}
      />
      <DataTable
        columns={columns}
        noHeader={true}
        highlightOnHover={true}
        data={users.items}
        customStyles={tableStyles}
        pagination={true}
        paginationServer={true}
        paginationPerPage={getPageLimit()}
        paginationDefaultPage={(filters.page || 0) + 1}
        paginationTotalRows={users.total}
        paginationRowsPerPageOptions={[50, 100, 200]}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        loading={loading}
        loadingRowsCount={10}
      />
    </div>
  );
};

export { Users };